import { render, staticRenderFns } from "./DurationDialog.vue?vue&type=template&id=05a92c1a&scoped=true&"
import script from "./DurationDialog.vue?vue&type=script&lang=js&"
export * from "./DurationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a92c1a",
  null
  
)

export default component.exports